<template>
  <b-embed
    class="youtube"
    :src="embedUrl"
    allowfullscreen
    webkitallowfullscreen
    mozallowfullscreen
    aspect="16by9"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  ></b-embed>
</template>

<script>
export default {
  name: 'ProgramVideo',
  props: {
    video: {
      type: String,
      default: null,
    },
  },
  computed: {
    embedUrl () {
      if (this.video?.startsWith('http')) {
        return this.video
      }

      return `https://www.youtube.com/embed/${this.video}`
    }
  }
};
</script>

<style scoped>
.youtube {
  max-width: 956px;
  max-height: 496px;
}
</style>
